import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { messagePerDayChart, topUsersChart } from "../services/chartServices"
import HourlyMsgCountChart from "./HourlyMsgCountChart";
import DailyMsgCountChart from "./DailyMsgCountChart";
import TopBotUsersChart from "./TopBotUsersChart";
import { useLocation } from "react-router-dom";
export default function BigChartPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const accessToken = useSelector((state) => state.auth.accessToken);
  const startDate = localStorage.getItem("startDate")
  const endDate = localStorage.getItem("endDate")
  const location = useLocation();
  useEffect(() => {
    const fetchChartData = async () => {
      try {
        setLoading(true);

        let response;

        if (location.pathname.includes("message-per-day")) {
          response = await messagePerDayChart({
            startDate,
            endDate,
            accessToken,
            withHour: false,
          });
        } else if (location.pathname.includes("message-per-hour")) {
          response = await messagePerDayChart({
            startDate,
            endDate,
            accessToken,
            withHour: true,
          });
        } else if (location.pathname.includes("top-users")) {
          response = await topUsersChart({
            startDate,
            endDate,
            accessToken,
          });
        }

        setData(response?.data || []);
      } catch (error) {
        console.error("خطا در دریافت داده:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchChartData();
  }, [location.pathname, startDate, endDate, accessToken]);

  if (loading) return <p>در حال بارگذاری نمودار...</p>;

  return (<>
    {location.pathname.includes("message-per-hour") && (
      <HourlyMsgCountChart messagePerHourChart={data} />
    )}
    {location.pathname.includes("message-per-day") && (
      <DailyMsgCountChart messagePerDaychartDate={data} />
    )}
    {location.pathname.includes("top-users") && (
      <TopBotUsersChart topUsersData={data} />
    )}
 
  </>)
}
